<div class="auth-container">
  <!-- LEFT IMAGE -->
  <div class="left-section">
    <img src="assets/images/login_image.jpg" alt="login" />
  </div>
  <!-- RIGHT FORM -->
  <div class="right-section">
    <div class="form-wrapper">
      <img
        src="assets/images/LoctitePulseLogo_red.svg"
        alt="forget-password"
        class="logo"
      />
      @if (!(authorizing || authorized || isLoggedIn)) {
        <div class="toast error">
          <i
            nz-icon
            class="inline-error-icon fillwhite"
            nzType="icons:error-exclamation-circle"
          ></i>
          <div class="toast-column">
            <span>{{ i18n.langString("change_password_unauthorized") }}</span>
            <a
              class="toast-link"
              [routerLink]=""
              (click)="onRequestNewMail()"
              >{{ i18n.langString("resend_mail") }}</a
            >
          </div>
        </div>
      }
      @if (error()) {
        <div class="toast error">
          <i
            nz-icon
            class="inline-error-icon fillwhite"
            nzType="icons:error-exclamation-circle"
          ></i>
          <span>{{ i18n.langString("changes_problem") }}</span>
        </div>
      }
      <app-common-form
        [formConfigureInput]="formConfiguration()"
        [submitText]="'Set New Password'"
        (formSubmit)="setNewPassword($event)"
        [isAdmin]="false"
        [passwordMatchAlert]="true"
        [formType]="'forgetPassword'"
        [hideTitle]="true"
      >
      </app-common-form>
    </div>
  </div>
</div>
